export const IMG_CDN_URL =
  "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_300,h_300,c_fit/";

export const API_URl =
  "https://foodfire.onrender.com/api/restaurants?lat=12.9351929&lng=77.624480699999991&page_type=DESKTOP_WEB_LISTING";

export const FETCH_MENU_URL =
  "https://foodfire.onrender.com/api/menu?page-type=REGULAR_MENU&complete-menu=true&lat=12.9351929&lng=77.624480699999991&&submitAction=ENTER&restaurantId=";
